import { Data } from "@cirrus/fe-lib"
import { Checkbox } from "@mui/material"
import T from "prop-types"
import React from "react"

import { FormControlLabel } from "../../mui-reexports.js"

import { useControlOverrides, useLabelOverrides } from "./css.js"

// export const LabeledCheckbox = ({ color = "primary", label, ...props }) =>
//   h(FormControlLabel, {
//     classes: useLabelOverrides(),

//     control: h(
//       Checkbox,
//       Data.merged(props, {
//         classes: useControlOverrides({ color }),
//         color: "default",
//       }),
//     ),

//     label,
//   })

export const LabeledCheckbox = ({ color = "primary", disabled, label, dataQa, ...props }) => {
  const formControlClasses = useLabelOverrides({ disabled })
  const checkboxClasses = useControlOverrides({ color, disabled })
  const checkboxProps = Data.merged(props, {
    classes: checkboxClasses,
    color: "default",
  })

  if (!label) {
    return <Checkbox {...checkboxProps} disabled={disabled} />
  }

  return (
    <FormControlLabel
      data-qa={dataQa}
      classes={formControlClasses}
      control={<Checkbox {...checkboxProps} disabled={disabled} />}
      label={label}
    />
  )
}

LabeledCheckbox.propTypes = {
  checked: T.bool,
  className: T.string,
  color: T.string,
  disabled: T.bool,
  label: T.string,
  onChange: T.func,
  size: T.oneOf(["medium", "small"]),
  value: T.any,
}
